let claimsCols = [
    {
        key: 'insuranceLine',
        display: 'Insurance Line'
    },
    {
        key: 'resellerName',
        display: 'Reseller'
    },
    {
        key: 'underwriterName',
        display: 'Underwriter'
    },
    {
        key: 'claimReference',
        display: 'Claim Reference'
    },
    {
        key: 'claimRelatedReference',
        display: 'Related Reference'
    },
    {
        key: 'incidentTypeDisplayLabel',
        display: 'Incident Type'
    },
    {
        key: 'imeiNo',
        display: 'IMEI'
    },
    {
        key: 'serialNo',
        display: 'Serial'
    },
    {
        key: 'cardPaymentDateAsLocalTime',
        display: 'Payment Date'
    },
    {
        key: 'cardPaymentCurrencyCode',
        display: 'Currency'
    },
    {
        key: 'cardPaymentAmount',
        display: 'Amount'
    },
    {
        key: 'cardPaymentStatusLabel',
        display: 'Payment Status'
    },
    {
        key: 'accountReference',
        display: 'Account Reference'
    },
    {
        key: 'processorToken',
        display: 'Processor Token'
    },
    {
        key: 'cardPaymentCardName',
        display: 'Name'
    },
    {
        key: 'cardPaymentLine1',
        display: 'Address Line 1'
    },
    
    {
        key: 'cardPaymentPostcode',
        display: 'Address Postcode'
    }
]

export { claimsCols }